/* eslint-disable jsdoc/check-param-names */
import { ActionBrick, registerBrick, ErrorFlow, BrickContext } from 'olympe';

export default class GetFromIndexedDB extends ActionBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} db
     * @param {string} store
     * @param {string} key
     * @param {function(): void} forwardEvent
     * @param {function(*): void} setDb
     * @param {function(*): void} setValue
     * @param {function(*): void} setErrorFlow
     */
    update($, [db, store, key], [forwardEvent, setDb, setValue, setErrorFlow]) {
        setDb(db);

        if (db.objectStoreNames.contains(store)) {
            const objectStore = db.transaction(store, 'readwrite').objectStore(store);
            const request = objectStore.get(key);
            request.onsuccess = (event) => {
                setValue(request.result?.v ?? request.result);
                forwardEvent();
            };
        } else {
            setErrorFlow(ErrorFlow.create("The store doesn't exist", 1));
        }
    }
}

registerBrick('018ae05fc638e8157df0', GetFromIndexedDB);
